/** 720p 24fps */
export const DEFAULT_VIDEO_CONSTRAINTS = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const INIT_MEDIA_INFO = {
  audioInputDevices: [],
  videoInputDevices: [],
  audioOutputDevices: [],
  hasAudioInputDevices: false,
  hasVideoInputDevices: false,
  mediaAPISupported: false,
};